

async function updateCartBubble() {
  const sections = await (await fetch("/?sections=header")).json();
  const doc = new DOMParser().parseFromString(sections.header, "text/html");
  const newCount = doc.querySelector("#cart-icon-bubble .cart-count-bubble");
  const currentCount = document.querySelector("#cart-icon-bubble .cart-count-bubble");
  if (newCount && currentCount) {
    currentCount.textContent = newCount.querySelector("span[aria-hidden='true']").textContent;
  }
}
// Size CHart Toggle End
  function updateCartDrawerUI() {
    fetch("/?section_id=cart-drawer")
      .then(res => res.text())
      .then(html => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, "text/html");
        const newCartItemsContainer = doc.querySelector(".cart-items");
        const newCartFooterContainer = doc.querySelector(".cart-drawer__footer");
        const currentCartItemsContainer = document.querySelector(".cart-items");
        const currentCartFooterContainer = document.querySelector(".cart-drawer__footer");
        if (newCartItemsContainer && currentCartItemsContainer) {
          currentCartItemsContainer.innerHTML = newCartItemsContainer.innerHTML;
          currentCartFooterContainer.innerHTML = newCartFooterContainer.innerHTML;
          updateCartBubble()
            document.querySelector(".pdp-loader-screen.loading")?.classList.remove("loading");
        }
      })
      .catch(err => console.error("Failed to update cart drawer items:", err));
  }
  

function submitProperties(btn){
  const container = btn.closest("product-info");
  const isColor = container.querySelector(".without-prescription .add-btn.active");
  const colorName = isColor ? container.querySelector(".color-grid .color-option.active").dataset.name : "";
  const colorVariant = isColor ? container.querySelector(".color-grid .color-option.active").dataset.variant : "";
  if(isColor){
    container.querySelector("#colorVal").value = colorName ;
  }else{
    // container.querySelector("#colorVal").value = "" ;
  }
  const isPres = container.querySelector(".with-prescription .add-btn.active");
  const prescription =isPres ? "Yes" : "No";
  container.querySelector("#prescriptionVal").value = isPres ? "yes" : "" ;
  let items = [];
  if(isColor || prescription!="No"){
      document.querySelector(".pdp-loader-screen").classList.add("loading");
  }
  // console.log("colorName" ,colorName)
  // console.log("colorVariant" ,colorVariant)
  // console.log("Prescription" ,prescription)
  
  const button = container.querySelector(".product-form__submit.button");
  
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.attributeName === "class") {
        if (!button.classList.contains("loading")) {
          addCustItems();
        }
      }
    });
  });
  
  observer.observe(button, { attributes: true });
  if (isColor) {
    items.push({
      id: colorVariant,
      quantity: 1,
      properties: {
        _type: "color Customization",
        Product: container.querySelector(".product__title h1").textContent.trim(),
        //   Color: colorName
      }
    });
  }
  
  if (isPres) {
    items.push({
      id: 47840203473155,
      quantity: 1,
      properties: {
        _type: "prescription Customization",
        Product: container.querySelector(".product__title h1").textContent.trim(),
      }
    });
  }
  function addCustItems() {
    if(items.length!=0){
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items })
      })
      .then(() => {
        items = [];
        updateCartDrawerUI();
      });
    }
      }
      };
      
      function checkoutProperties(btn){
        openModificationBox(btn)
        const container = btn.closest("product-info");
        container.querySelector(".product-form__submit.button").click();
      }
      